module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fbc2ebc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/App.vue